import React, { FC } from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import styles from './nav_document_analyzer.module.scss';
import { NewChip } from '../../components/chips/NewChip';

export const NavDocumentAnalyzer: FC = () => (
  <Hyperlink
    className="nav__item nav__item__desktop"
    href="/document_analyzer?source=nav"
  >
    <NewChip className={styles.chip} />
    Document Analyzer
  </Hyperlink>
);
